"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapWithFirebaseAndDispatch = mapWithFirebaseAndDispatch;
exports.wrapInDispatch = wrapInDispatch;

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapInDispatch(dispatch, _ref) {
  let {
    meta,
    method,
    args = [],
    types
  } = _ref;
  const [requestingType, successType, errorType] = types;
  dispatch({
    type: (0, _isObject2.default)(requestingType) ? requestingType.type : requestingType,
    meta,
    payload: (0, _isObject2.default)(requestingType) ? requestingType.payload : {
      args
    }
  });
  return method(...args).then(payload => {
    dispatch({
      type: (0, _isObject2.default)(successType) ? successType.type : successType,
      meta,
      payload: (0, _isObject2.default)(successType) ? successType.payload : payload
    });
    return payload;
  }).catch(err => {
    dispatch({
      type: errorType,
      meta,
      payload: err
    });
    return Promise.reject(err);
  });
}

function createWithFirebaseAndDispatch(firebase, dispatch, dispatchFirst) {
  return func => function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return func.apply(firebase, dispatchFirst ? [dispatch, firebase, ...args] : [firebase, dispatch, ...args]);
  };
}

function mapWithFirebaseAndDispatch(firebase, dispatch, actions, reverseActions) {
  const withFirebaseAndDispatch = createWithFirebaseAndDispatch(firebase, dispatch);
  const withDispatchAndFirebase = createWithFirebaseAndDispatch(firebase, dispatch, true);
  return { ...(0, _mapValues2.default)(actions, withFirebaseAndDispatch),
    ...(0, _mapValues2.default)(reverseActions, withDispatchAndFirebase)
  };
}